const $3a338f00c40ffba0$var$pause = (pauseTime)=>new Promise((resolve)=>setTimeout(resolve, pauseTime));
const $3a338f00c40ffba0$var$typePhraseAndDelete = async (phrase, targetElement, { typeSpeed: typeSpeed, deleteSpeed: deleteSpeed, deleteAfter: deleteAfter })=>{
    let n = -1;
    while(++n <= phrase.length){
        targetElement.innerText = phrase.slice(0, n);
        await $3a338f00c40ffba0$var$pause(typeSpeed);
    }
    await $3a338f00c40ffba0$var$pause(deleteAfter);
    while(--n >= 0){
        targetElement.innerText = phrase.slice(0, n);
        await $3a338f00c40ffba0$var$pause(deleteSpeed);
    }
};
const $3a338f00c40ffba0$var$runTyper = async (targetElement, options)=>{
    const phrases = targetElement.dataset.items?.split(',')?.map((it)=>it.trim());
    if (!phrases || phrases.length === 0) return;
    let currentPhraseIndex = 0;
    while(true){
        await $3a338f00c40ffba0$var$typePhraseAndDelete(phrases[currentPhraseIndex], targetElement, options);
        await $3a338f00c40ffba0$var$pause(options.pauseAfterPhrase);
        currentPhraseIndex++;
        if (currentPhraseIndex >= phrases.length) currentPhraseIndex = 0;
    }
};
const $3a338f00c40ffba0$export$2b7d35df5485fe27 = ({ typeSpeed: typeSpeed = 100, deleteSpeed: deleteSpeed = 50, deleteAfter: deleteAfter = 2000, pauseAfterPhrase: pauseAfterPhrase = 300 } = {})=>{
    [].slice.call(document.querySelectorAll('[data-typer]')).forEach((item)=>{
        $3a338f00c40ffba0$var$runTyper(item, {
            typeSpeed: typeSpeed,
            deleteSpeed: deleteSpeed,
            deleteAfter: deleteAfter,
            pauseAfterPhrase: pauseAfterPhrase
        });
    });
};


const $548ef821533e7fbb$export$b08464e47b7a3a8 = ()=>{
    let mapElement = null;
    let mapInstance = null;
    window.initMap = ()=>{
        const { google: google } = window;
        mapElement = document.getElementById('map');
        if (!mapElement || !google) return;
        const { maps: { LatLng: LatLng, MapTypeId: MapTypeId, Map: Map, Marker: Marker } } = google;
        const theWellPosition = new LatLng(52.3739128, 0.928362);
        const mapOptions = {
            center: theWellPosition,
            zoom: 14,
            mapTypeId: MapTypeId.ROADMAP,
            scrollwheel: false
        };
        mapInstance = new Map(mapElement, mapOptions);
        new Marker({
            position: theWellPosition,
            map: mapInstance,
            title: 'The Well, Hopton'
        });
    };
    // this is the function that gm calls if it cannot authenticate, see
    // https://developers.google.com/maps/documentation/javascript/events#auth-errors
    window.gm_authFailure = ()=>{
        console.error('Caught map load error - falling back to image');
        const fallbackElement = document.createElement('div');
        fallbackElement.className = 'map-fallback';
        mapElement?.parentNode?.appendChild(fallbackElement);
        mapElement?.parentNode?.removeChild(mapElement);
    };
};


let $33a7099d58553396$var$navOpen = false;
const $33a7099d58553396$var$toggleNav = ({ overlayElement: overlayElement, navElement: navElement })=>{
    const method = $33a7099d58553396$var$navOpen ? 'remove' : 'add';
    overlayElement.classList[method]('active');
    navElement.classList[method]('active');
    $33a7099d58553396$var$navOpen = !$33a7099d58553396$var$navOpen;
};
const $33a7099d58553396$export$e5cdb55e8355be12 = ()=>{
    const overlayElement = document.querySelector('[data-overlay]');
    const navElement = document.querySelector('[data-mobile-nav]');
    if (!overlayElement || !navElement) return;
    [].slice.call(document.querySelectorAll('[data-toggle-nav]')).forEach((item)=>{
        item.addEventListener('click', (e)=>{
            e.preventDefault();
            $33a7099d58553396$var$toggleNav({
                overlayElement: overlayElement,
                navElement: navElement
            });
        });
    });
};


const $8e71c1d634ae6951$var$polyfills = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=Promise';
const $8e71c1d634ae6951$export$644a581e345c719a = ()=>typeof Promise === 'undefined';
const $8e71c1d634ae6951$export$f0cc6f64db5149b8 = (done)=>{
    const scriptEl = document.createElement('script');
    scriptEl.src = $8e71c1d634ae6951$var$polyfills;
    scriptEl.onload = ()=>done();
    scriptEl.onerror = ()=>done(new Error('Failed to load script ' + $8e71c1d634ae6951$var$polyfills));
    document.head.appendChild(scriptEl);
};


const $257ba3995936ae97$var$main = ()=>{
    (0, $3a338f00c40ffba0$export$2b7d35df5485fe27)();
    (0, $548ef821533e7fbb$export$b08464e47b7a3a8)();
    (0, $33a7099d58553396$export$e5cdb55e8355be12)();
};
if ((0, $8e71c1d634ae6951$export$644a581e345c719a)()) (0, $8e71c1d634ae6951$export$f0cc6f64db5149b8)((error)=>{
    if (error) console.error(error);
    else $257ba3995936ae97$var$main();
});
else $257ba3995936ae97$var$main();


//# sourceMappingURL=error.62c4c650.js.map
